import React, { useEffect } from "react";
import { LookerEmbedSDK } from "./src/index";

function LookerDashboard({ dashboardId }: { dashboardId: number }) {
  useEffect(() => {
    LookerEmbedSDK.init("citiesense.cloud.looker.com", "/auth");

    const setupDashboard = (dashboard) => {
      document.querySelector("#run").addEventListener("click", () => {
        dashboard.send("dashboard:run");
      });
      return <div />;
    };

    LookerEmbedSDK.createDashboardWithId(dashboardId)
      .withDynamicIFrameHeight()
      .appendTo("#looker-dashboard")
      .on("dashboard:run:start", () =>
        console.log(`Starting dashboard run for ID: ${dashboardId}`)
      )
      .on("dashboard:run:complete", () =>
        console.log(`Starting dashboard run for ID: ${dashboardId}`)
      )
      .build()
      .connect()
      .then(setupDashboard)
      .catch((error) => {
        console.error("An unexpected error occurred", error);
      });
  }, [dashboardId]);

  return <div id="looker-dashboard" />;
}

export default LookerDashboard;
